import type { TrackingEvent, TrackingPayload } from '../types'

const useUserActionEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => any,
  { $tracking }: any,
) => {
  const { getUserPayload } = useTrackingUserPayload()

  return {
    trackLogin: async () =>
      track('login', {
        method: 'standard_email',
        user: await getUserPayload(),
      }),

    trackRegister: async (newsletter: boolean) => {
      track('sign_up', {
        method: 'standard_email',
        user: await getUserPayload(),
        newsletter_signup: newsletter,
      })
    },

    trackNewsletterSubmit: async (email: string) => {
      track('newsletter_submit', {
        newsletter_email: email,
        user: await getUserPayload(),
      })
    },

    trackGoldnerClubSubmit: async (email: string) => {
      track('goldner_club_submit', {
        goldner_club_email: email,
        user: await getUserPayload(),
      })
    },

    trackVirtualPageView: async (payload: TrackingPayload) => {
      $tracking.push({
        event: 'virtual_page_view',
        user: await getUserPayload(),
        ...payload,
      })
    },
  }
}

export default useUserActionEvents
